import { render, staticRenderFns } from "./TeamsAuthorize.vue?vue&type=template&id=5235eeb4&"
import script from "./TeamsAuthorize.vue?vue&type=script&lang=ts&"
export * from "./TeamsAuthorize.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports